<template>
  <div id="login">
    <el-row class="login-info" :style="styles">
      <el-col :span="24" style="margin-bottom:20px;font-size:20px;">
        <b>忘记密码</b>
      </el-col>
      <el-col v-if="step" style="font-size: 18px;text-align: left;margin-left: 5%;color: #C0C4CC"
              :span="24">
        验证手机号
      </el-col>

      <el-col v-if="step" style="display: flex" :span="24">
        <div style="width:38%;font-size: 16px;text-align: left;margin-left: 5%;color: #C0C4CC;margin-top: 10px">
          请输入注册手机号码:
        </div>
        <el-input
          style="width: 52%;margin-bottom: 10px"
          placeholder="请输入手机号码"
          v-model="phonenumber"
        ></el-input>
      </el-col>
      <el-col v-if="step" :span="24">
        <el-input class="login-input" placeholder="请输入短信验证码" v-model="smsCode">
          <el-button
            :disabled="smscodeDisabled"
            style="font-size:12px !important;"
            slot="append"
            v-if="setCode"
            @click="getYzm"
          >{{ setCode }}
          </el-button>
        </el-input>
      </el-col>
      <el-col v-if="!step" :span="24">
        <el-input
          class="login-input"
          placeholder="请输入密码"
          show-password
          v-model="pre_password"
        ></el-input>
      </el-col>
      <el-col v-if="!step" :span="24">
        <el-input
          class="login-input"
          placeholder="再次输入密码"
          show-password
          v-model="password"
        ></el-input>
      </el-col>
      <el-col v-if="step" :span="24">
        <el-button style="width:90%;" type="primary" @click="checkSmsCode">下一步</el-button>
      </el-col>
      <el-col v-if="!step" :span="24">
        <el-button style="width:90%;" type="primary" @click="submit">提交</el-button>
      </el-col>
      <el-col :span="24" class="reg-text">
        <router-link :to="{path:'/login'}" style="font-size:12px;">登录</router-link>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import count from "@/api/home";
import {forgetSmsCode, updatePwd} from "../api/home";

export default {
  name: "Login",
  data() {
    return {
      step: true,
      smscodeDisabled: false,
      phonenumber_after: "",
      setCode: "获取验证码",
      phonenumber: "",
      smsCode: "",
      address: "",
      pre_password: "",
      password: "",
      companyName: "",
      username: "",
      count: 60,
      show: true,
      timer: "",
    };
  },
  computed: {
    styles() {
      return {
        width: this.$store.state.app.device == 'desktop' ? '400px' : `${document.body.clientWidth - 10}px`,
        top: this.$store.state.app.device == 'desktop' ? '20%' : '15%',
        left: this.$store.state.app.device == 'desktop' ? '65%' : '5px',
      }
    }
  },
  mounted() {
  },
  methods: {
    // 获取短信验证码
    getYzm() {
      if (this.phonenumber === "") {
        return this.$message.error("请输入注册手机号");
      }
      if (!this.validatePhoneNumber(this.phonenumber)) {
        return this.$message.error("录入的手机号码格式有误");
      }
      let data = {mobile: this.phonenumber};
      count.forgetSmsCode(data).then((res) => {
        if (res.code === 0) {
          this.$message.success("验证码已发送 请注意查收");
          this.validateBtn();
        } else {
          this.$mesage.error(res.msg);
        }
      });
    },
    validateBtn() {
      //倒计时
      let time = 60;
      let timer = setInterval(() => {
        if (time == 0) {
          clearInterval(timer);
          this.smscodeDisabled = false;
          this.setCode = "发送验证码";
        } else {
          this.smscodeDisabled = true
          this.setCode = time + "秒后重试";
          time--;
        }
      }, 1000);
    },
    // 手机号做脱敏处理
    phoneHide(phone) {
      let reg = /^(1[3-9][0-9])\d{4}(\d{4}$)/; // 定义手机号正则表达式
      phone = phone.replace(reg, '$1****$2');
      return phone;
    },
    validatePhoneNumber(number) {
      const regEx = /^[1][3-9]\d{9}$/;
      return regEx.test(number);
    },
    // 下一步
    checkSmsCode() {
      if (this.phonenumber === "") {
        return this.$message.error("请输入注册手机号");
      }
      if (!this.validatePhoneNumber(this.phonenumber)) {
        return this.$message.error("录入的手机号码格式有误");
      }
      if (this.smsCode === "") {
        return this.$message.error("请输入手机验证码");
      }
      const data = {
        phoneNumber: this.phonenumber,
        smsCode: this.smsCode,
      };
      count.checkSmsCode(data).then((res) => {
        if (res.code === 0) {
          this.step = !this.step;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    submit() {
      if (this.pre_password === "") {
        return this.$message.error("请输入密码");
      }
      if (this.password === "") {
        return this.$message.error("请再次输入密码");
      }
      if (this.pre_password !== this.password) {
        return this.$message.error("两次输入的密码不一致");
      }
      const data = {
        phone: this.phonenumber,
        pwd: this.password,
        smsCode: this.smsCode,
      };
      count.updatePwd(data).then((res) => {
        if (res.code === 0) {
          this.$message.success("修改成功！请重新登录");
          this.$parent.$children[0].quit()
          this.$router.push("/login");
        } else {
          this.$message.error(res.msg);
        }
      })
    }
  },
};
</script>

<style scoped>
.code-btn {
  color: #ef8466;
  font-size: 12px !important;
  border: none;
  background-color: #f5f7fa;
  cursor: pointer;
}

.getCaptcha {
  display: block;
  width: 100px;
  height: 35px;
}

#login {
  text-align: center;
  font-size: 20px;
  width: 100%;
  height: calc(100vh - 414px);
  min-height: 600px;
  /* background-size: 80% 80%; */
  background: url("../assets/images/register.png");
  background-position: center;
  padding-top: 64px;
}

.login-info {
  position: relative;
  /* left: 23%; */
  /* top: 30%; */
  /* width: 20%; */
  /* margin: 0 auto; */
  background-color: #fff;
  box-shadow: 10px 10px 10px #f2f2f2;
  border-radius: 10px;
  padding: 10px 0;
}

.foot-end {
  font-size: 12px;
  margin-top: 30px;
  padding-top: 10px;
  text-align: center;
  color: #939393;
  position: fixed;
  bottom: 0;
  margin: 0 auto;
  width: 100%;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.login-input {
  width: 90%;
  margin-bottom: 10px;
}

.link {
  text-decoration: underline;
  color: #409eff;
  cursor: pointer;
  font-size: 12px;
}

.cursor-pointer {
  cursor: pointer;
}

.reg-text {
  font-size: 12px !important;
  text-align: right;
  width: 95%;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/ForestPwd.vue